/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления маркетплейсами.
 * Маркетплейсы используются как точки дистрибьюции ключей
 */

/**
 * Сервис управления маркетплейсами
 */
export class MarketplaceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения маркетплейса.
   * Поддерживает создание и обновление.
   * Метод доступен для: manager, service, application(ad:edit)
   */
  PostMarketplace = (req: PostMarketplaceRequestDto, init?: RequestInit): Promise<PostMarketplaceResponseDto> => {
    return fm.request<PostMarketplaceRequestDto, PostMarketplaceResponseDto>(`${this.host}/ad/api/v1/marketplace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения маркетплейса.
   * Не требует авторизации
   */
  GetMarketplace = (req: GetMarketplaceRequestDto, init?: RequestInit): Promise<GetMarketplaceResponseDto> => {
    return fm.request<GetMarketplaceRequestDto, GetMarketplaceResponseDto>(`${this.host}/ad/api/v1/marketplace/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка маркетплейсов.
   * Не требует авторизации
   */
  GetMarketplaceList = (req?: GetMarketplaceListRequestDto, init?: RequestInit): Promise<GetMarketplaceListResponseDto[]> => {
    return fm.list<GetMarketplaceListRequestDto, GetMarketplaceListResponseDto>(`${this.host}/ad/api/v1/marketplace/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества маркетплейсов.
   * Не требует авторизации
   */
  GetMarketplaceCount = (req?: GetMarketplaceCountRequestDto, init?: RequestInit): Promise<GetMarketplaceCountResponseDto> => {
    return fm.request<GetMarketplaceCountRequestDto, GetMarketplaceCountResponseDto>(`${this.host}/ad/api/v1/marketplace/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов маркетплейсов
 */
export enum MarketplaceType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Озон
   */
  OZON = "OZON",
  /**
   * Вайлдберриз
   */
  WILDBERRIES = "WILDBERRIES",
  /**
   * Яндекс маркет
   */
  YANDEX_MARKET = "YANDEX_MARKET",
  /**
   * Яндекс маркет
   */
  SBER_MARKET = "SBER_MARKET",
}
/**
 * Справочник типов маркетплейсов
 */
export type MarketplaceTypeResponseEnum = keyof typeof MarketplaceType
/**
 * Справочник типов маркетплейсов
 */
export type MarketplaceTypeRequestEnum = Exclude<MarketplaceTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Запрос получения количества маркетплейсов
 */
export type GetMarketplaceCountRequestDto = {
}
/**
 * Ответ на запрос получения количества маркетплейсов
 */
export type GetMarketplaceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего маркетплейсов
   */
  readonly data: number
}>
/**
 * Запрос получения списка маркетплейсов
 */
export type GetMarketplaceListRequestDto = {
}
/**
 * Ответ на запрос получения списка маркетплейсов
 */
export type GetMarketplaceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Маркетплейс
   */
  readonly data: MarketplaceResponseDto
}>
/**
 * Запрос получения маркетплейса
 */
export type GetMarketplaceRequestDto = {
  /**
   * Идентификатор маркетплейса
   */
  id: number
}
/**
 * Ответ на запрос получения маркетплейса
 */
export type GetMarketplaceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Маркетплейс
   */
  readonly data: MarketplaceResponseDto
}>
/**
 * Маркетплейс
 */
export type MarketplaceRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Название
   */
  title: string
  /**
   * Тип маркетплейса
   */
  type: MarketplaceTypeRequestEnum
  /**
   * Выключен ли маркетплейс
   */
  isDisabled?: boolean
  /**
   * Ссылка на карточку товара ключа в маркетплейсе
   */
  cardUrl?: string | null
}
/**
 * Маркетплейс
 */
export type MarketplaceResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Название
   */
  title: string
  /**
   * Тип маркетплейса
   */
  type: MarketplaceTypeResponseEnum
  /**
   * Выключен ли маркетплейс
   */
  isDisabled: boolean
  /**
   * Ссылка на карточку товара ключа в маркетплейсе
   */
  cardUrl: string | null
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
}
/**
 * Запрос сохранения маркетплейса
 */
export type PostMarketplaceRequestDto = {
  /**
   * Маркетплейс
   */
  data: MarketplaceRequestDto
}
/**
 * Ответ на запрос сохранения маркетплейса
 */
export type PostMarketplaceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Маркетплейс
   */
  readonly data: MarketplaceResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества маркетплейсов
   */
  "GetMarketplaceCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества маркетплейсов",
  },
  /**
   * Ответ на запрос получения количества маркетплейсов
   */
  "GetMarketplaceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества маркетплейсов",
    "fields": {
      /**
       * Всего маркетплейсов
       */
      "data": {
        "type": "int32",
        "text": "Всего маркетплейсов",
      },
    },
  },
  /**
   * Запрос получения списка маркетплейсов
   */
  "GetMarketplaceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка маркетплейсов",
  },
  /**
   * Ответ на запрос получения списка маркетплейсов
   */
  "GetMarketplaceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка маркетплейсов",
    "fields": {
      /**
       * Маркетплейс
       */
      "data": {
        "type": "Marketplace",
        "text": "Маркетплейс",
      },
    },
  },
  /**
   * Запрос получения маркетплейса
   */
  "GetMarketplaceRequest": {
    "kind": "class",
    "text": "Запрос получения маркетплейса",
    "fields": {
      /**
       * Идентификатор маркетплейса
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор маркетплейса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения маркетплейса
   */
  "GetMarketplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения маркетплейса",
    "fields": {
      /**
       * Маркетплейс
       */
      "data": {
        "type": "Marketplace",
        "text": "Маркетплейс",
      },
    },
  },
  /**
   * Маркетплейс
   */
  "Marketplace": {
    "kind": "class",
    "text": "Маркетплейс",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Название
       */
      "title": {
        "type": "string",
        "text": "Название",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип маркетплейса
       */
      "type": {
        "type": "Marketplace.Type",
        "text": "Тип маркетплейса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Выключен ли маркетплейс
       */
      "isDisabled": {
        "type": "bool",
        "text": "Выключен ли маркетплейс",
      },
      /**
       * Ссылка на карточку товара ключа в маркетплейсе
       */
      "cardUrl": {
        "type": "google.protobuf.StringValue",
        "text": "Ссылка на карточку товара ключа в маркетплейсе",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
    },
  },
  /**
   * Запрос сохранения маркетплейса
   */
  "PostMarketplaceRequest": {
    "kind": "class",
    "text": "Запрос сохранения маркетплейса",
    "fields": {
      /**
       * Маркетплейс
       */
      "data": {
        "type": "Marketplace",
        "text": "Маркетплейс",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения маркетплейса
   */
  "PostMarketplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения маркетплейса",
    "fields": {
      /**
       * Маркетплейс
       */
      "data": {
        "type": "Marketplace",
        "text": "Маркетплейс",
      },
    },
  },
  /**
   * Справочник типов маркетплейсов
   */
  "Marketplace.Type": {
    "kind": "enum",
    "text": "Справочник типов маркетплейсов",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Озон
       */
      "OZON": {
        "i": 1,
        "text": "Озон",
      },
      /**
       * Вайлдберриз
       */
      "WILDBERRIES": {
        "i": 2,
        "text": "Вайлдберриз",
      },
      /**
       * Яндекс маркет
       */
      "YANDEX_MARKET": {
        "i": 3,
        "text": "Яндекс маркет",
      },
      /**
       * Яндекс маркет
       */
      "SBER_MARKET": {
        "i": 4,
        "text": "Яндекс маркет",
      },
    },
  },
}